import { useCallback } from 'react';

export const useGoogleAnalytics = () => {
  // Track form submissions
  const trackFormSubmission = useCallback(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'form_submission', {
        'event_category': 'Contact',
        'event_label': 'Contact Form Submit'
      });
    }
  }, []);

  // Track calculator interactions
  const trackCalculatorUse = useCallback((turnoverAmount) => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'calculator_use', {
        'event_category': 'Engagement',
        'event_label': 'Calculator',
        'value': turnoverAmount
      });
    }
  }, []);

  // Track phone clicks
  const trackPhoneClick = useCallback(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'phone_click', {
        'event_category': 'Contact',
        'event_label': 'Phone Number Click'
      });
    }
  }, []);

  // Track email clicks
  const trackEmailClick = useCallback(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'email_click', {
        'event_category': 'Contact',
        'event_label': 'Email Click'
      });
    }
  }, []);

  return {
    trackFormSubmission,
    trackCalculatorUse,
    trackPhoneClick,
    trackEmailClick
  };
}; 